import { FC } from 'react';
import { AdminClientLayout } from 'pages/atoms';
import { AdminTransmissionActsList } from 'containers/admin';

const AdminClientTransmissionActsPage: FC = () => {
  return (
    <AdminClientLayout>
      <AdminTransmissionActsList />
    </AdminClientLayout>
  );
};

export default AdminClientTransmissionActsPage;
